import { validarSesion } from "./Auth";
const config = require("../env.json")

export const obtenerProyectos=async(token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/proyectos`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const ingresarProyecto=async(proyecto,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/proyectos`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"POST",
            body:JSON.stringify(proyecto)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
export const obtenerProyecto=async(proyectoId,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/proyectos/`+proyectoId;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
           
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const actualizarProyecto=async(proyecto,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/proyectos`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"PUT",
            body:JSON.stringify(proyecto)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
export const deshabilitarProyecto=async(proyectoid,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/proyectos/`;
    const resp=await fetch(url,
        {
            method:"DELETE",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
            },
            body:JSON.stringify({ProyectoId:proyectoid})
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
};